import { ActionTypes } from "../constants/index";
import { loadState } from "../localStorage";

//const token = localStorage.getItem("token");
const appState = loadState();

export default function auth(
	state = {
		isFetching: false,
		errorMessage: "",
		//isAuthenticated: !!token,
		...appState,
	},
	action = ""
) {
	switch (action.type) {
		case ActionTypes.LOGIN_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
				isAuthenticated: false,
			});
		case ActionTypes.LOGIN_SUCCESS:
			return Object.assign({}, state, {
				isAuthenticated: true,
				user: action.user,
			});
		case ActionTypes.LOGIN_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				isAuthenticated: false,
				errorMessage: action.payload,
			});
		case ActionTypes.LOGOUT_SUCCESS:
			return Object.assign({}, state, {
				isAuthenticated: false,
			});
		case ActionTypes.SET_USER_KEYS:
			return Object.assign({}, state, action.data);
		default:
			return state;
	}
}
